/* angular:styles/component:css;767055b813effe3012c1d5e6255c8d79c9185dd148a5336706ffb82f37477290;/app/src/app/shared/animations/search-box.component.ts */
.disable-selection {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.container-standard {
  padding-left: 0px;
  padding-right: 8px;
  position: inherit;
  z-index: 1;
  max-height: 100%;
  height: fit-content;
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 3px 8px 0 rgba(140, 140, 140, 0.5);
  border: solid 1px #c8c7cc;
  background-color: #ffffff;
}
.container-fixed {
  padding-left: 0px;
  padding-right: 8px;
  position: fixed;
  z-index: 1010;
  max-height: 100%;
  height: fit-content;
  border-radius: 8px;
  box-shadow: 0 3px 8px 0 rgba(140, 140, 140, 0.5);
  border: solid 1px #c8c7cc;
  background-color: #ffffff;
}
.header {
  padding-left: 16px;
  font-family: Lato;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #8f8e95;
}
.items-container {
  padding-left: 8px;
  padding-right: 8px;
}
.item {
  width: 100%;
  height: 33px;
  border-radius: 20px;
  background-color: #ffffff;
  cursor: pointer;
  position: relative;
}
.item-text {
  position: absolute;
  left: 8px;
  top: 8px;
  vertical-align: sub;
  font-family: "Poppins-Regular";
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #333333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: calc(100% - 12px);
  cursor: pointer;
}
.item-text-bold {
  position: absolute;
  left: 8px;
  top: 8px;
  vertical-align: sub;
  font-family: "Poppins-Regular";
  font-size: 13px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #333333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: calc(100% - 12px);
  cursor: pointer;
}
.spacer {
  padding-bottom: 8px;
}
.top-bottom-padding {
  padding-top: 16px;
  padding-bottom: 16px;
  height: fit-content;
  display: block;
  overflow-y: auto;
  overflow-x: hidden;
}
.form-div {
  position: relavtive;
  padding-left: 16px;
  padding-right: 8px;
}
.form-img {
  position: absolute;
  left: 16px;
  top: 12px;
}
.form-text {
  border: 0px;
  width: 100%;
  height: 38px;
  font-family: Lato;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  padding-inline-start: 24px;
}
input:focus {
  outline: none;
}
.line {
  width: 100%;
  height: 1px;
  background-color: #c8c7cc;
}
::-webkit-scrollbar {
  width: 5px;
}
::-webkit-scrollbar-thumb {
  background: #d8d8d8;
  border-radius: 3px;
  padding: 16px 13px;
}
/*# sourceMappingURL=search-box.component.css.map */
